import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = {
  key: 1,
  class: "text-plain"
};
import { ref, watch, nextTick } from '../../../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { getBoundingClientRectSync } from '@tencentcloud/universal-api';
import { translator } from '../../../utils/translation';
export default /*@__PURE__*/_defineComponent({
  __name: 'translation-content',
  props: {
    message: {
      default: () => ({})
    },
    translationContentVisible: {
      type: Boolean
    },
    isSingleTranslation: {
      type: Boolean
    },
    translationWrapperRef: {}
  },
  emits: ["toggleErrorStatus"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var translationFinished = ref(false);
    var translationErrorText = ref('');
    var translationTextList = ref([]);
    var calculateHeight = ref(0);
    var calculateWidth = ref(0);
    var translationLoadingRef = ref();
    var translationContentRef = ref();
    watch(() => props.translationContentVisible, newVal => {
      if (newVal) {
        translator.get(props.message).then(result => {
          translationFinished.value = true;
          translationTextList.value = result;
          nextTick(() => {
            var {
              height: originHeight,
              width: originWidth
            } = getBoundingClientRectSync(translationLoadingRef.value);
            var {
              height,
              width
            } = getBoundingClientRectSync(translationContentRef.value);
            calculateHeight.value = originHeight;
            calculateWidth.value = originWidth;
            requestAnimationFrame(() => {
              calculateHeight.value = height;
              calculateWidth.value = width;
              if (props.isSingleTranslation) {
                nextTick(() => {
                  var {
                    bottom
                  } = getBoundingClientRectSync(props.translationWrapperRef);
                  var {
                    bottom: bottomWindow
                  } = getBoundingClientRectSync('#messageScrollList');
                  if (bottom > bottomWindow) {
                    var timer = setTimeout(() => {
                      props.translationWrapperRef.scrollIntoView({
                        block: 'end',
                        behavior: 'smooth'
                      });
                      clearTimeout(timer);
                    }, 150);
                  }
                });
              }
            });
          });
        }).catch(err => {
          translationFinished.value = true;
          var {
            height: originHeight
          } = getBoundingClientRectSync(translationLoadingRef.value);
          calculateHeight.value = originHeight;
          translationTextList.value = [];
          emits('toggleErrorStatus', true);
          translationErrorText.value = err.message;
        });
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "message-translation-container",
        style: _normalizeStyle({
          height: _unref(calculateHeight) > 0 ? "".concat(_unref(calculateHeight), "px") : 'auto',
          width: _unref(calculateWidth) > 0 ? "".concat(_unref(calculateWidth), "px") : 'auto'
        })
      }, [_unref(translationFinished) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "translationContentRef",
        ref: translationContentRef,
        class: _normalizeClass({
          'translation-content': true,
          'occur': _unref(calculateHeight) > 0
        })
      }, [_unref(translationTextList).length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_unref(translationTextList), (text, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index
        }, [text.type === 'face' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "text-face",
          src: text.value
        }, null, 8, _hoisted_1)) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(text.value), 1))]);
      }), 128)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode(_toDisplayString(_unref(translationErrorText)), 1)], 64))], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        ref_key: "translationLoadingRef",
        ref: translationLoadingRef,
        class: _normalizeClass({
          'loading': true,
          'loading-end': _unref(translationFinished)
        })
      }, _toDisplayString(_unref(TUITranslateService).t('TUIChat.翻译中')) + "... ", 3)], 4);
    };
  }
});